module.exports = __webpack_public_path__ + "img/DhlSe.cdfa043d.png";